<template>
    <div class='profile'>
        <myBanner :imgSrc="imgSrc"/>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><span @click="$router.go(-1)">返回</span></el-breadcrumb-item>
            <el-breadcrumb-item>我的资料</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="showMobile">
            <div class="dashed"></div>
        </div>
        <!-- 表格区域 -->
        <div class="content mobileWidth">
            <div class="tip showPc">注：带 <span>*</span> 必填</div>
            <div class="menueItem showMobile">
                <img src="~assets/img/book.png" alt="">
                <div class="tip">注：带 <span>*</span> 必填</div>
            </div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
                <el-form-item label="微信昵称">
                    <el-input v-model="nickName" disabled></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入姓名，与身份证一致"></el-input>
                </el-form-item>
                <el-form-item label="手机" prop="mobile">
                    <el-input v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="medium" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { getDataMixin } from "common/mixin.js"
    import { getThemeList } from "network/home.js"
    import { updateInfo } from "network/application.js"
    import {wxUserInfo} from "network/login.js"
    import {isCellPhone} from "common/libs.js"
    export default {
        name:"myOrder",
        mixins:[getDataMixin],
        data(){
            var checkphone = (rule, value, callback) => {
                if (value == "") {
                    callback(new Error("请输入手机号"));
                } else if (!isCellPhone(value)) {
                    callback(new Error("请输入正确的手机号!"));
                } else {
                    callback();
                }
            };
            return{
                imgSrc:[],
                nickName:'',
                ruleForm: {
                    name:'',
                    mobile:''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, validator: checkphone, trigger: 'blur' }
                    ],
                }
            }
        },
        created(){
            this.getThemeListData(1,100)
            this.getWxUserInfo()
        },
        methods:{

            //接口请求
            getThemeListData(page,pageSize) {
                getThemeList({
                    page,
                    pageSize
                }).then(res => {
                    let data = res.data.records[this.getNavIndex - 1]
                    if(data){   
                        let bannerData = data.themeBanners
                        if(bannerData.length && bannerData.length == 2){
                            for(let i in bannerData){
                                bannerData.push(bannerData[i])
                            }
                            this.imgSrc = bannerData
                        }else if(bannerData.length){
                            this.imgSrc = bannerData
                        }
                    }
                });
            },
            // 用户信息
            getWxUserInfo(){
                wxUserInfo().then(res=>{
                    if(res.code == 1){
                        this.nickName = res.data.nickName
                        this.ruleForm.name = res.data.realName
                        this.ruleForm.mobile = res.data.mobile
                    }
                })
            },

            // 事件
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        updateInfo({
                            realName:this.ruleForm.name,
                            mobile:this.ruleForm.mobile
                        }).then(res=>{
                            if(res.code == 1){
                                this.$store.dispatch('getChangRealNameState',true)
                                this.$message({
                                    type:'success',
                                    message:res.msg
                                })
                                setTimeout(()=>{
                                    if(this.getFlag){
                                        this.$router.push('/index')
                                    }else{
                                        this.$router.go(-1)
                                    }
                                },1000)
                                
                            }
                        })
                    } else {
                        return false;
                    }
                });
            }
        },
        computed:{
            getFlag(){
                return this.$route.query.flag ? this.$route.query.flag : ''
            }
        }
    }
</script>
<style scoped lang="scss">
    .el-breadcrumb__inner span{
        cursor: pointer;
    }
    .content{
        padding-bottom: 10px;
        width:40%;
        margin:0 auto;
        .tip{
            margin:20px 0 20px 12px;
            font-size: 14px;
            color:var(--color-main);
            span{
                color:#F56C6C;
            }
        }
    }
    

@media screen and (max-width: 768px){
    .menueItem{
        display: flex;
        font-size:0.28rem;
        border-bottom: 1px solid var(--color-border);
        padding:0.3rem 0 0.2rem;
        margin-bottom: 0.3rem;
        img{
            height: 0.3rem;
        }
        .tip{
            margin:0;
            color:var(--color-text);
            margin-left:0.2rem;
            span{
                color:#F56C6C;
            }
        }
    }
    .content{
        padding-bottom: 0.2rem;
        width:90%;
        margin:0 auto;
    }
}
</style>